import React from "react";
import DesktopContainer from "./Container/DesktopContainer";
import MobileContainer from "./Container/MobileContainer";

class ContainerComponent extends React.Component {
  render() {
    return (
      <div>
        <DesktopContainer {...this.props}>
          {this.props.children}
        </DesktopContainer>
        <MobileContainer {...this.props}>{this.props.children}</MobileContainer>
      </div>
    );
  }
}

export default ContainerComponent;



// WEBPACK FOOTER //
// ./src/components/ContainerComponent.js